import axios from "axios";

// const API_BASE_URL = "https://gisul-backend.vercel.app";
const API_BASE_URL = "https://api.snibo.co";
// const API_BASE_URL = "http://localhost:8080";


// Axios instance
const api = axios.create({
  baseURL: API_BASE_URL
});

// Reusable API call function
export const apiCall = async (endpoint, method = "GET", data = null, headers = {}) => {
  try {
    //Check this is Form Data Or Not
    const isFormData = data instanceof FormData;
    const token = localStorage.getItem("GISUL_TOKEN");
    const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await api({
      url: endpoint,
      method,
     ...(method !== "DELETE" || data !== null ? { data } : {}),
      headers: {
        ...headers,
        ...(isFormData
          ? authHeader
          : {
              "Content-Type": "application/json",
              ...authHeader
            })
      }
    });

    return response.data;
  } catch (error) {
    console.error("API Call Error:", error);
    throw error;
  }
};

export const jwtHeaders = () => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("GISUL_TOKEN")}`
  };
  return headers;
};
